import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 * This is a `smart` component. It will pass along an impression info for an
 * impression of the same ID, if it has been fired
 *
 */
import { connect } from 'react-redux';
import { wrapWithClickProps } from './click';

var wrapWithImpressionClickProps = function wrapWithImpressionClickProps(component) {
  return connect(function (state, ownProps) {
    if (state.impressions && state.impressions[ownProps.id]) {
      var impression = state.impressions[ownProps.id];

      var props = _objectSpread({}, ownProps);

      props.eventProps = _objectSpread({
        clickHeader: impression.impressionHeader
      }, props.eventProps);
      return props;
    }

    return ownProps;
  })(wrapWithClickProps(component));
};

export default wrapWithImpressionClickProps('a');
export { wrapWithImpressionClickProps };